"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerStakeInstruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const token_1 = require("@project-serum/anchor/dist/cjs/utils/token");
const pda_getters_1 = require("../pda_getters");
const utils_1 = require("../utils");
/**
 * Returns an instruction which registers a token for staking
 *
 * @param connection
 * @param authorityAccount - Public key of account which will be set as the staking program authority
 * @param programId - Deployed program ID for Staking program
 */
function registerStakeInstruction({ connection, authority, rewardMultiplier, stakeMint, rewardMint, cooldownPeriod, programId, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, utils_1.getStakingProgram)({ connection, programId });
        const ixSet = {
            instructions: [],
            signers: [],
        };
        const [registeredStake] = yield (0, pda_getters_1.getRegisteredStake)(programId, authority, stakeMint, rewardMint);
        const rewardAta = yield (0, token_1.associatedAddress)({
            owner: registeredStake,
            mint: rewardMint,
        });
        const ix = yield program.methods
            .registerStake(new anchor_1.BN(rewardMultiplier), new anchor_1.BN(cooldownPeriod))
            .accounts({
            authority,
            stakeMint,
            rewardMint,
            rewardAta,
        })
            .instruction();
        ixSet.instructions.push(ix);
        return ixSet;
    });
}
exports.registerStakeInstruction = registerStakeInstruction;
//# sourceMappingURL=registerStake.js.map